<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入用户名称"
        v-model.trim="name"
        class="input-item mr10"
      ></el-input>
      <el-input
        size="small"
        placeholder="输入搜索内容"
        v-model.trim="content"
        class="input-item mr10"
      ></el-input>
      <el-select
        v-model="manageOpen"
        class="input-item mr10"
        placeholder="显示状态"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column
        prop="nickname"
        width="200"
        header-align="center"
        label="用户名称"
      ></el-table-column>
      <el-table-column width="320px"
        header-align="center"
        label="内容"
      >
        <template #default="scope">
            <template v-if="scope.row.content">
            <div v-if="scope.row.content.length > 21">
            <el-popover
              placement="right"
              :width="400"
              trigger="hover"
              :content="scope.row.content"
            >
            <div class="content" style="max-height: 300px;overflow-y: auto;">
              <p><pre v-html="scope.row.content"></pre></p>
            </div>
              <template #reference>
                <span>{{ $utils.subString(scope.row.content, 21) }}</span>
              </template>
            </el-popover>
          </div>
          <div v-else>
            {{ scope.row.content }}
          </div>
            </template>
        </template>
      </el-table-column>
      <el-table-column prop="time" width="180" label="发布时间" align="center">
      </el-table-column>
      <el-table-column prop="likeNum" label="点赞数" align="center">
      </el-table-column>
      <el-table-column prop="commentNum" label="评论数" align="center">
      </el-table-column>
      <el-table-column  label="查看详情" align="center">
        <template #default="scope">
          <el-button type="text" size="mini" @click="info(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="公开状态" align="center" :formatter="status">
      </el-table-column>
      <el-table-column label="展示状态" align="center">
        <template #default="scope">
            <el-tag type="success" v-if="scope.row.manageOpen">展示</el-tag>
            <el-tag v-else type="danger">隐藏</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作" align="center">
        <template #default="scope">
          <el-button
            v-if="scope.row.manageOpen"
            type="danger"
            size="mini"
            @click="setData(scope.row.id, 0)"
            >隐藏</el-button
          >
          <el-button
            v-if="!scope.row.manageOpen"
            type="success"
            size="mini"
            @click="setData(scope.row.id, 1)"
            >展示</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 查看详情 -->
    <el-dialog v-model="dialogVisible" title="动态详情" width="800px">
      <div class="dialog-content">
        <ul>
          <li>
            <span>用户名：</span><span>{{ itemData.data.nickname }}</span>
          </li>
          <li>
            <span>内容：</span>
            <span>
              <p><pre v-html="itemData.data.content"></pre></p>
            </span>
          </li>
          <li><span>图片：</span><span>{{itemData.data.imgs.length===0?'无':''}}</span></li>
        </ul>
        <div>
          <el-image
            v-for="item in itemData.data.imgs"
            :key="item"
            :src="$utils.fileUrl(item)"
            fit="cover"
            :preview-src-list="srcList(itemData.data.imgs)"
          ></el-image>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
            <el-button
            v-if="itemData.data.manageOpen"
            type="danger"
            size="mini"
            @click="setData(itemData.data.id, 0)"
            >隐藏</el-button
          >
          <el-button
            v-if="!itemData.data.manageOpen"
            type="success"
            size="mini"
            @click="setData(itemData.data.id, 1)"
            >展示</el-button
          >

          <el-button size="mini" type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
import api from "./../../../api/index.js";
import NProgress from "nprogress";
import utils from "../../../utils/utils";

export default {
  setup() {
    const content = ref("");
    const name = ref("");
    const manageOpen = ref(2);
    let data = reactive({ records: [], current: 0, total: 0 });
    const options = reactive([
      { label: "全部", value: 2 },
      { label: "展示", value: 1 },
      { label: "不展示", value: 0 },
    ]);
    let dialogVisible = ref(false);

    const getData = async (page = 1) => {
      if (content.value.length > 30) {
        ElMessage.warning("搜索内容最多输入30个字");
        return;
      }

      const params = {
        content: content.value,
        name: name.value,
        manageOpen: manageOpen.value === 2 ? null : manageOpen.value,
        currentPage: page,
        pageSize: 20,
      };
      try {
        NProgress.start();
        const res = await api.dynamic.getData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.records = res.data.records;
          data.current = res.data.current;
          data.total = res.data.total;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    getData();

    const setData = async (id, status) => {
      const params = {
        sayId: id,
        manageOpen: status,
      };
      try {
        NProgress.start();
        const res = await api.dynamic.setData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.data = res.data;
          getData(data.current);
          dialogVisible.value = false;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    let itemData = reactive({ data: {} });
    const info = (data) => {
      let i = 1;
      let imgs = [];
      while (i < 10) {
        if (data[`img${i}`]) {
          imgs.push(data[`img${i}`]);
        }
        i++;
      }
      itemData.data = { ...data };
      itemData.data.imgs = imgs;
      dialogVisible.value = !dialogVisible.value;
    };

    const srcList = (imgs) => {
      return imgs.map((item) => {
        return utils.fileUrl(item);
      });
    };

    const status = (row) => {
      switch (row.status) {
        case 1:
          return "公开";
        case 2:
          return "不公开";
        case 3:
          return "好友可见";
        case 4:
          return "分组不可见";
      }
    };

    return {
      content,
      name,
      manageOpen,
      data,
      options,
      getData,
      setData,
      info,
      dialogVisible,
      itemData,
      srcList,
      status,
    };
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;

  .input-item {
    width: 180px;
  }
}

.dialog-content {
  ul {
    li {
      display: flex;
      line-height: 30px;
      span {
        &:first-child {
          width: 60px;
        }

        &:last-child {
          flex: 1;
        }
      }
    }
  }

  .el-image {
    width: 150px;
    height: 85px;
  }
}
</style>